import React from 'react';
import { Modal } from 'antd';
import loadingGif from '../assets/arte.gif';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .ant-modal-content,
  .ant-modal-body {
    background-color: transparent !important;
    box-shadow: none !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent !important;
`;

const Loading = ({ isVisible }) => {
    
  return (
    <StyledModal
      open={isVisible}
      closable={false}
      footer={null}
      centered={false}
      maskClosable={false}
      style={{ top: '20%' }}
      wrapClassName="transparent-modal"
    >
      <LoadingContainer>
        <img 
          src={loadingGif} 
          alt="Cargando..." 
          style={{
            width: '400px', 
            height: '400px'
          }} 
        />
      </LoadingContainer>
    </StyledModal>
  );
};

export default Loading;

